@let formControl = control();

@if (formControl) {
  @if (field().validation?.isRequired || formControl.invalid) {
    <div
      class="x-font-body-5 text-center font-extrabold"
      [ngClass]="{
        'x-text-wf-error': formControl.invalid,
      }"
    >
      @if (formControl.hasError('required')) {
        <span>Обязательное поле</span>
      } @else if (formControl.hasError('customError')) {
        <span>Ошибка валидации</span>
      } @else {
        <span>Обязательно к заполнению</span>
      }
    </div>
  }
  <x-request-form-deal-details
    [isInsideWorkflow]="true"
    [canExecuteWorkflow]="canExecute()"
  />
}
